export default __webpack_public_path__ + "assets/turkmenistan-flag.png";